const organisationKey = 'organisationName';

export const setOrganisationName = (organisationName: string) => {
    window.sessionStorage.setItem(organisationKey, organisationName);
};

export const getOrganisationName = (): string | null => {
    return window.sessionStorage.getItem(organisationKey);
};
